import Marquee from "react-fast-marquee";

const WORDS = ["Registration", "GST", "Income Tax", "ROC & MCA", "Labour Law", "Trademark", "Accounting", "Audit", "Virtual CFO"];

export const EditorialMarquee = () => (
  <section className="relative overflow-hidden border-y border-white/10 bg-navy-950 py-8 md:py-10" data-testid="editorial-marquee">
    <Marquee gradient={false} speed={70} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className={`px-6 text-5xl font-extrabold tracking-tighter md:text-6xl ${i % 2 === 0 ? "text-stroke-gold" : "text-stroke-emerald"}`}>
            {w}
          </span>
          <span className={`h-2.5 w-2.5 rounded-full ${i % 2 === 0 ? "bg-gold-500" : "bg-emerald2-400"}`} />
        </span>
      ))}
    </Marquee>
  </section>
);
